import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";


const CandidateHistoryState = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [offerReport, setOfferReport] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [candidateList, setCandidateList] = useState([]);
  const [apiStatus, SetApiStatus] = useState('');
  const [statusList, setStatusList] = useState([]);
  const [filterFormData, setFilterData] = useState([]);
  const [respStatus, setRepStatus] = useState(0);

  const columns = {
    FullName: { text: "Name", visible: true },
    JobTitle: { text: "Job Title", visible: true },
    CandidateReferralType: { text: "Source", visible: true },
    ReferralName: { text: "Referred By", visible: true },
    CreatedByName: { text: "Created By", visible: true },
    CandidateStatus: { text: "Status", visible: true },
    ActualJoiningDate: { text: "Act. DOJ", align: "center", visible: true },
  };

  const dispatch = useDispatch();
  const location = useLocation();
  const passedState = location.state
  useEffect(() => {
    dispatch(updateNavbarHeading(passedState ? passedState?.text : "Candidate History Statement "))
  }, [passedState]);



  const [originalData, setOriginalData] = useState([]);


  // Apply URL filters
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const candidate = queryParams.get('CandidateStatus')?.trim().toLowerCase();
    console.log("candidate::", candidate);

    const filteredData = originalData.filter(item => {
      return candidate
        ? item.CandidateStatus?.trim().toLowerCase() === candidate
        : true;
    });

    console.log("filteredData", filteredData);

    setOfferReport(filteredData);
  }, [location.search, originalData]);



  const formDatas = [
    { name: "Created By", type: "Select", options: [...hrNameList] },
    { name: "Job Title", type: "Select", options: [...jobList] },
    { name: "Candidate", type: "Select", options: [...candidateList] },
    { name: "Status", type: "Select", options: [...statusList] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchCandidateHistory = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}candidate-history?CandidateJobDescriptionID=&CandidateStatus=&CandidateID=&HRName=`);
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.headers;
        setOfferReport(data);
        setOriginalData(data)

        // Hr Name List
        const hrList = response?.data?.hr?.original?.Hr?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);

        // Job Title
        const jobTitleList = response?.data?.jobtitle?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setJobList(jobTitleList);

        // status list
        const statusList = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatusList(statusList);

        // candidate List
        const candidateList = response?.data?.candidates?.map((item) => ({
          value: item.value,
          label: item.text,
        }))
        setCandidateList(candidateList);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchCandidateHistory();
  }, []);

  const handleGetData = async () => {
    SetApiStatus(undefined)

    try {
      const response = await GetServiceCaller(`${API_URL}candidate-history?CandidateJobDescriptionID=${filterFormData.find((o) => o.label === "Job Title")
        ? filterFormData.find((o) => o.label === "Job Title").value
        : 0
        }&CandidateStatus=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }&CandidateID=${filterFormData.find((o) => o.label === "Candidate")
          ? filterFormData.find((o) => o.label === "Candidate").value
          : 0
        }&HRName=${filterFormData.find((o) => o.label === "Created By")
          ? filterFormData.find((o) => o.label === "Created By").value
          : 0
        }`);
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.headers;
        setOfferReport(data);
        setOriginalData(data)

        // Hr Name List
        const hrList = response?.data?.hr?.original?.Hr?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setHRNameList(hrList);

        // Job Title
        const jobTitleList = response?.data?.jobtitle?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setJobList(jobTitleList);

        // status list
        const statusList = response?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatusList(statusList);

        // candidate List
        const candidateList = response?.data?.candidates?.map((item) => ({
          value: item.value,
          label: item.text,
        }))
        setCandidateList(candidateList);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleView = (id) => {
    navigate(`/candidate-history/view/${id.ID}`);
  }


  const handleReset = () => {
    setOfferReport([])
    setFilterData([])
    fetchCandidateHistory()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handleReset={handleReset}
              showIcon1={true}
              isSorting={true}
              isFilterRequired={true}
              isActionRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
              handleIcon1={handleView}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View History",
              }}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default CandidateHistoryState;
